import { render, staticRenderFns } from "./peachForm.vue?vue&type=template&id=f1518aea&scoped=true&"
import script from "./peachForm.vue?vue&type=script&lang=js&"
export * from "./peachForm.vue?vue&type=script&lang=js&"
import style0 from "./peachForm.vue?vue&type=style&index=0&id=f1518aea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1518aea",
  null
  
)

export default component.exports